import React from "react";
import DynamicLayout from "../components/DynamicLayout";
import { Link } from "react-router-dom";

const SettingsPage = () => {
  return (
    <DynamicLayout>
      <div
        className="full-screen-image-container margin-top-0"
        style={{
          backgroundImage: `url('/img/saturnwallpaper.jpg')`,
        }}
      >
        <ul className="has-text-centered hoofdstukken">
          <h1 className="title has-text-primary has-text-weight-semibold">Privacy settings</h1>
          <Link to="/profile"> <li></li></Link>
          <Link to="/privacy"> <li></li></Link>
          <Link to="/premium"> <li></li></Link>
        

        </ul>

      </div>

    </DynamicLayout>
  )};

export default SettingsPage;

